import config from '@/config';

class AdobeEmbedPdfViewer {
  constructor() {
    this.readyPromise = new Promise(resolve => {
      if (window.AdobeDC) {
        resolve();
      } else {
        document.addEventListener('adobe_dc_view_sdk.ready', () => {
          resolve();
        });
      }
    });
    this.adobeDCView = undefined;
  }

  ready() {
    return this.readyPromise;
  }

  previewFile(divId, viewerConfig, url, fileName, locale) {
    // the clientId is defined per domain (including any subdomains). This means we have a different clientId for app.adminpulse.be, app.adminpulse.nl and also one for localhost
    // the clients can be found at https://developer.adobe.com/console/projects (login with support@adminpulse.be)
    const clientId = config.appUrls.app.endsWith('.nl')
      ? 'b0e72949c25f43caa10f79632271eef0'
      : config.appUrls.app.endsWith('.be')
      ? 'b33a485daf9a425ab59a2b013025df62'
      : 'cf39a1ceb2b3418da6c415a6a76233d1';

    const adobeEmbedConfig = {
      clientId,
      divId,
      locale: locale.includes('nl') ? 'nl-NL' : locale.includes('fr') ? 'fr-FR' : 'en-US',
    };

    this.adobeDCView = new window.AdobeDC.View(adobeEmbedConfig);

    return this.adobeDCView.previewFile(
      {
        content: {
          location: {
            url,
          },
        },
        metaData: {
          fileName: fileName ?? 'preview.pdf',
        },
      },
      viewerConfig,
    );
  }
}
export default AdobeEmbedPdfViewer;
